export default __webpack_public_path__ + "static/media/returns.7943c4f9.svg";